/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowBackIosNew: {
  name: 'arrow-back-ios-new';
  data: string;
} = {
  name: 'arrow-back-ios-new',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z"/></svg>`
};
